/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FilterType = {
    Equals: 0,
    NotEquals: 1,
    Contains: 2,
    NotContains: 3,
    StartsWith: 4,
    EndsWith: 5,
    LessThan: 6,
    GreaterThan: 7,
    LessThanOrEqual: 8,
    GreaterThanOrEqual: 9
} as const;
export type FilterType = typeof FilterType[keyof typeof FilterType];

